import EditPacing from './component'
export default EditPacing
